import { useState } from "react";
import { Buton, Uyari } from "@kantin/ui";
import { medyaYukle, useMedyaGoruntusu } from "../../veri/medya.js";
import { hataMetni } from "./ortak.js";

export interface FisBelgesi { medya_id: string; dosya_adi: string | null }

export function FisFotografi({ belge }: { belge: FisBelgesi }) {
  const { url, hata, yukleniyor } = useMedyaGoruntusu(belge.medya_id);
  return <figure className="m-0 rounded-md border border-cizgi p-3">
    {yukleniyor && <p role="status">Fotoğraf yükleniyor…</p>}
    {hata && <p role="alert" className="text-hata">{hata}</p>}
    {url && <a href={url} target="_blank" rel="noreferrer" aria-label={`${belge.dosya_adi ?? "Fiş"} fotoğrafını büyüt`}>
      <img src={url} alt={belge.dosya_adi ?? "Mal kabul fişi"} className="max-h-96 w-full object-contain" />
    </a>}
    <figcaption className="mt-2 break-words text-xs text-murekkep-3">{belge.dosya_adi ?? "Fiş fotoğrafı"}</figcaption>
  </figure>;
}

export function MalKabulBelgeleri({ belgeler, degistir, mesgulDegistir }: {
  belgeler: FisBelgesi[];
  degistir: (belgeler: FisBelgesi[]) => void;
  mesgulDegistir: (deger: boolean) => void;
}) {
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState<string | null>(null);
  async function yukle(dosyalar: File[]) {
    if (!dosyalar.length) return;
    setHata(null);
    if (belgeler.length + dosyalar.length > 10) { setHata("En fazla 10 fotoğraf ekleyebilirsiniz."); return; }
    if (dosyalar.some((d) => !["image/jpeg", "image/png", "image/webp"].includes(d.type) || d.size > 10 * 1024 * 1024)) {
      setHata("Her fotoğraf en fazla 10 MB, JPEG, PNG veya WEBP olmalıdır."); return;
    }
    setYukleniyor(true);
    mesgulDegistir(true);
    const yeni = [...belgeler];
    try {
      for (const dosya of dosyalar) {
        const sonuc = await medyaYukle(dosya, "mal_kabul_fis");
        yeni.push({ medya_id: sonuc.medya_id, dosya_adi: sonuc.dosya_adi });
        degistir([...yeni]);
      }
    } catch (e) { setHata(hataMetni(e)); }
    finally { setYukleniyor(false); mesgulDegistir(false); }
  }
  return <section aria-label="Fiş fotoğrafları" className="flex flex-col gap-3">
    <label className="text-sm font-medium" htmlFor="mal-kabul-fotograflar">Fiş fotoğrafları (isteğe bağlı)</label>
    <input id="mal-kabul-fotograflar" type="file" accept="image/jpeg,image/png,image/webp" multiple
      disabled={yukleniyor || belgeler.length >= 10} aria-describedby="fis-foto-ipucu"
      onChange={(e) => { const dosyalar = Array.from(e.target.files ?? []); e.target.value = ""; void yukle(dosyalar); }} />
    <p id="fis-foto-ipucu" className="m-0 text-xs text-murekkep-3">Fotoğraf eklemeden tamamlayabilirsiniz. En fazla 10 fotoğraf, her biri 10 MB. Uzun fişleri parça parça çekebilirsiniz. Yükledikten sonra taslağı kaydedin.</p>
    {yukleniyor && <p role="status">Fiş fotoğrafları yükleniyor…</p>}
    {hata && <Uyari tur="hata" baslik="Fotoğraf yüklenemedi">{hata}</Uyari>}
    <div className="grid gap-3 md:grid-cols-2">{belgeler.map((b) => <div key={b.medya_id}>
      <FisFotografi belge={b} />
      <Buton type="button" disabled={yukleniyor} onClick={() => degistir(belgeler.filter((x) => x.medya_id !== b.medya_id))}>Fotoğrafı kaldır</Buton>
    </div>)}</div>
  </section>;
}
